module.exports = __webpack_public_path__ + "static/media/full_7.8f1bd4c8.jpg";